import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
/** Skeleton Table */
const SkeletonRow = ({ cols }) => (
  <>
    <Stack
      display="flex"
      alignItems="center"
      justifyContent="space-around"
      flexDirection="row"
      flexWrap="nowrap"
      py={1}
      px={2}
      spacing={5}
    >
      {Array.from({ length: cols }).map((_, index) => (
        <Skeleton
          key={index}
          variant="text"
          sx={{ fontSize: "1.2rem" }}
          width={100}
          animation="wave"
        />
      ))}
    </Stack>
    <Skeleton variant="rounded" width="100%" height={1} />
  </>
);

export const TableSkeleton = ({ rows = 10, cols = 5 }) => {
  return (
    <Box minHeight="50vh">
      <Skeleton variant="rounded" width="100%" height={54} animation="wave" />

      {Array.from({ length: rows }).map((_, index) => (
        <SkeletonRow key={index} rows={rows} cols={cols} />
      ))}

      <Stack
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        flexDirection="row"
        flexWrap="nowrap"
        py={3}
        px={2}
        spacing={10}
      >
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            key={index}
            variant="text"
            sx={{ fontSize: "1.2rem" }}
            width={100}
            animation="wave"
          />
        ))}
      </Stack>
    </Box>
  );
};
